import "./AnalyticsApproach.css";
import arrow from '../../scalability/scalabiltyassets/arrowimg.png';
import icon1 from '../../computing/computingassets/icon1.png';
import icon2 from '../../computing/computingassets/icon2.png';
import icon3 from '../../computing/computingassets/icon3.png';
import icon4 from '../../computing/computingassets/icon4.png';
import icon5 from '../../computing/computingassets/icon5.png';

const steps = [
  {
    icon: icon1,
    title: "Assessment & Cloud Readiness Planning",
    desc: "Evaluate applications, infrastructure, and security requirements.",
  },
  {
    icon: icon2,
    title: "Architecture Design & Migration Strategy",
    desc: "Design optimized cloud architectures and migration roadmaps.",
  },
  {
    icon: icon3,
    title: "Automation & DevOps Integration",
    desc: "Implement CI/CD, IaC, and monitoring for efficient operations.",
  },
  {
    icon: icon4,
    title: "Security, Compliance & Governance",
    desc: "Embed security and compliance across cloud environments.",
  },
  {
    icon:icon5,
    title: "Monitoring, Optimization & Continuous Improvement",
    desc: "Continuously monitor performance, costs, and scalability.",
  },
];

export default function AnalyticsApproach() {
  return (
    <section id="analytics-approach" className="outsourcemainclass">
      <h2 className="heading">Our Cloud Implementation Approach</h2>
      <p className="subheading">
        A Structured Framework for Reliable and High-Performance Cloud Adoption
      </p>

      <div className="steps">
        {steps.map((step, index) => (
          <div className="step" key={index}>
           <img src={step.icon} alt="error" className="icon" />
            <h4>{step.title}</h4>
            <p>{step.desc}</p>

            {index !== steps.length - 1 && <img src={arrow} alt="error" className="arrow"/>}
          </div>
        ))}
      </div>
    </section>
  );
}
